import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import {
  AvailableOrderTypes,
  IMealCredit,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';

export const getAvailableOrderTypes = (
  validOrderTypes: IMealCredit['valid_order_types']
): IMealCreditFormFields['availableOrderTypes'] =>
  validOrderTypes.map((type) => AvailableOrderTypes[type]);
